// extracted by mini-css-extract-plugin
module.exports = {"nestedTable":"src-components-tables-ContractDetailsTables-JutloDetailsTable-JutloDetailsTable-module__nestedTable--RiNgK"};